import { Injectable, inject } from '@angular/core';

import { SharedService } from './shared.service';

@Injectable({ providedIn: 'root' })
export class DynamicTitleService {
  private sharedService = inject(SharedService);

  private readonly DEFAULT_SCOPE = 'DEFAULT';

  private mapping: Record<string, Record<string, string>> = {
    DEFAULT: {
      loc_list: 'Locations',
      loc_view: 'View Location',
      loc_edit: 'Edit Location',
      loc_create: 'New Location',

      site_list: 'Sites',
      site_view: 'View Site',
      site_edit: 'Edit Site',
      site_create: 'New Site'
    },

    NDT: {
      loc_list: 'Locations',
      loc_view: 'View Location',
      loc_edit: 'Edit Location',
      loc_create: 'New Location',

      site_list: 'Sites',
      site_view: 'View Site',
      site_edit: 'Edit Site',
      site_create: 'New Site'
    },

    HOME: {
      loc_list: 'Rooms',
      loc_view: 'View Room',
      loc_edit: 'Edit Room',
      loc_create: 'New Room',

      site_list: 'Locations',
      site_view: 'View Location',
      site_edit: 'Edit Location',
      site_create: 'New Location'
    }
  };

  private resolveScope(industry: string): string {
    return this.mapping[industry] ? industry : this.DEFAULT_SCOPE;
  }

  getTitle(key: string): string {
    const scope = this.resolveScope(this.sharedService.kiIndustryType);

    return this.mapping[scope][key] ?? key;
  }
}
